
import Productpage from './productpage.vue'

export default {
	Productpage
}



// WEBPACK FOOTER //
// ./src/views/detail/index.js